import { APIPath, InviteType } from 'utility/constant'
import { AuthService } from './auth'
import { BaseService } from './base'

const invitingCompany = () => {
    const user = AuthService.getUser() || {}
    const company = user.Companies?.[0] || {}
    return {
        companyId: Number(user.CompanyId || company.CompanyId) || 0,
        companyName: user.CompanyName || company.CompanyName || '',
        createdBy: Number(user.unique_id || user.UserId) || 0,
    }
}

class InviteUser {
    // TeamMember is scoped to the inviter's company. SendInviteToken only
    // links the new member when CompanyId and CreatedBy are on the body.
    sendInvitation(reqData) {
        const { companyId, companyName, createdBy } = invitingCompany()
        const list = (Array.isArray(reqData) ? reqData : [reqData]).map(
            item => ({
                ...item,
                InviteType: item.InviteType || InviteType.Email,
                CompanyId: Number(item.CompanyId) || companyId,
                CompanyName: item.CompanyName || companyName,
                CreatedBy: Number(item.CreatedBy) || createdBy,
                RoleId: Number(item.RoleId) || 0,
            }),
        )
        return BaseService.post(APIPath.sendInvitation, list)
    }

    // InviteToken has no LoginSource member. Send only the fields this screen has.
    validateInvitation({ InviteTo, InviteCode } = {}) {
        return BaseService.postExact(
            APIPath.validateInvitation,
            {
                InviteTo,
                InviteCode,
            },
            false,
        )
    }

    // Only the email, code, and new password. Extra zeros would replace the
    // company, role, and name already stored on the invite.
    inviteSetPassword({ InviteTo, InviteCode, Password } = {}) {
        return BaseService.postExact(
            APIPath.setPassword,
            { InviteTo, InviteCode, Password },
            false,
        )
    }
}
const InviteUserService = new InviteUser()
Object.freeze(InviteUserService)
export { InviteUserService }
